import dateformat from 'dateformat'
import { connect } from 'react-redux'

import { StrollerIcon } from 'components/icons'
import { getArrivalDate, getArrivalKnown } from 'registry/reducers'

import SetupGoal from './setup-goal'

function getText(state) {
  if (getArrivalKnown(state) == null) return "When's this little bean arriving?"

  const arrivalDate = getArrivalDate(state)
  if (!arrivalDate) return 'Arriving soon...'

  return (
    <span>
      Arriving
      <br />
      {dateformat(arrivalDate, 'UTC:mmmm dS')}.
    </span>
  )
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <StrollerIcon />,
    text: getText(state),
  }
}

export default connect(mapStateToProps)(SetupGoal)
